<template>
  <IviewModal
    v-bind="$attrs"
    @on-cancel="$emit('input', false)"
    :title="data.ppType == 'add' ? '添加默认角色' : '编辑默认角色'"
    @on-ok="save"
    size="large"
    @on-visible-change="open"
  >
    <div class="node-content">
      <Form ref="form" :model="form" :rules="rules">
        <FormItem label="角色名称:" prop="name">
          <IviewInput v-model="form.name" placeholder="请输入名称" />
        </FormItem>
        <FormItem label="角色适用节点:">
          <el-radio-group v-model="form.orgLevel" size="small" @change="nodeChange" :disabled="data.ppType != 'add'">
            <el-radio-button :label="item.orgLevel" v-for="(item, i) in orangList" :key="i">{{
              item.orgLevelName
            }}</el-radio-button>
          </el-radio-group>
        </FormItem>
        <FormItem label="管理范围:" prop="parentManageRange">
          <div class="vertical">
            <IviewRadioGroup v-model="form.parentManageRange" :radioList="scopeSelect()" vertical />
            <!-- <div class="tree-wrap" v-if="form.parentManageRange == '1'">
              <Tree :data="organTree" show-checkbox ref="organTree"></Tree>
            </div> -->
          </div>
        </FormItem>
        <FormItem label="选择部门或本人:" prop="dep">
          <div class="dep">
            <el-radio-group v-model="form.scope" size="small">
              <el-radio-button label="按部门">按部门</el-radio-button>
              <el-radio-button label="仅本人">仅本人</el-radio-button>
            </el-radio-group>
            <div class="tip">将根据管理范围中所选的组织内配置</div>
            <div class="dep-radio" v-if="form.scope == '按部门'">
              <IviewRadioGroup v-model="form.manageRange" :radioList="depList" vertical />
            </div>
          </div>
        </FormItem>
        <FormItem label="功能权限:" prop="selectArr">
          <div>
            <div class="select-per">
              <IviewCheckbox :value="selectArr.length >= moduleList.length" @on-change="allChange">全部</IviewCheckbox>
              <IviewCheckboxGroup @on-change="moduleChange" v-model="selectArr" :optionList="moduleList" />
            </div>
            <div class="model-wrap">
              <div class="top">
                <el-radio-group v-model="form.currentModule" size="small">
                  <el-radio-button
                    v-show="selectArr.includes(item.label)"
                    v-for="(item, i) in rootModuleList"
                    :key="i"
                    :label="item.label"
                    >{{ item.label }}</el-radio-button
                  >
                </el-radio-group>
                <div class="line"></div>
                <IviewCheckboxGroup v-model="form.ptArr" :optionList="treeData" />
                <div class="right" v-if="isRelation">
                  <IviewCheckbox v-model="form.isAccos">权限关联</IviewCheckbox>
                  <el-tooltip popper-class="tooltip-auto">
                    <div slot="content">
                      若勾选权限关联,此后将同步对各端权限的操作
                      <br />若需要单独配置权限,则只需取消勾选
                    </div>
                    <img src="~_img/common/doubt.png" alt="" />
                  </el-tooltip>
                </div>
              </div>
              <ul class="tree-list">
                <li v-for="(item, i) in treeData" :key="item.label" v-show="form.ptArr.includes(item.label)">
                  <div class="t1">{{ item.label }}</div>
                  <div v-for="(tree, k) in item.tree" :key="k">
                    <IviewTree2
                      v-show="form.currentModule == tree.title"
                      v-model="tree.treeCode"
                      :treeData="[tree]"
                      ref="tree"
                      @change="(data) => assocChange(data, i, tree.title)"
                    />
                  </div>
                  <div v-if="!item.tree.find((item) => item.title == form.currentModule)" class="no-tree">暂无数据</div>
                </li>
              </ul>
            </div>
          </div>
        </FormItem>
      </Form>
    </div>
  </IviewModal>
</template>

<script>
import { transitionData } from '@/utils'
import { getRules } from '@/utils/check'
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      orangList: [],
      scopeSelect: () =>
        this.form.orgLevel == this.orangList.length
          ? [
              { label: '归属组织', tip: '（该角色所工作的组织）', value: 4 }
              // { label: '指定组织', tip: '（可指定所选节点"含全部下级节点"的全部组织）', value: 1 }
            ]
          : [
              { label: '归属组织及全部下级组织', tip: '（该角色所工作的组织及全部下级组织）', value: 2 },
              { label: '归属组织和下级组织', tip: '（该角色所工作的组织及下一级组织）', value: 3 },
              { label: '归属组织', tip: '（该角色所工作的组织）', value: 4 }
              // { label: '指定组织', tip: '（可指定所选节点"含全部下级节点"的全部组织）', value: 1 }
            ],
      depList: [
        { label: '全部部门', tip: '（所选组织的全部部门）', value: 3 },
        { label: '归属部门和下级部门', tip: '（该角色所工作的部门及全部下级部门）', value: 2 },
        { label: '归属部门', tip: '（该角色所工作的部门）', value: 4 }
      ],
      form: {
        model: [],
        model2: '模块1',
        treeCode: [],
        tree: [],
        scope: '按部门',
        manageRange: '',
        parentManageRange: '',
        orgLevel: 1,
        isAccos: false,
        currentModule: '',
        ptArr: this.$root.permissionTree.map((item) => item.name)
      },
      selectArr: [],
      organTree: [],
      moduleList: [],
      treeCode: [],
      organCode: [],
      defaultCode: [],
      rootModuleList: this.$root.permissionModules,
      permissionTree: this.$root.permissionTree,
      treeData: [],
      isRelation: false,
      rules: {
        ...getRules([
          { label: '角色名称', key: 'name' },
          { label: '管理范围', key: 'parentManageRange', type: 'number', radio: true }
        ]),
        dep: [
          {
            required: true,
            validator: (rule, value, callback, source, options) => {
              if (this.form.scope == '按部门' && !this.form.manageRange) {
                callback('请选择部门')
              }
              callback()
            }
          }
        ],
        selectArr: [
          {
            required: true,
            validator: (rule, value, callback, source, options) => {
              if (this.selectArr.length == 0) {
                callback('请至少分配一个模块')
              }
              callback()
            }
          }
        ]
      }
    }
  },
  created() {
    this.$api.config.getNode().then((res) => {
      this.orangList = res.data
    })
    this.nodeChange()
    // 是否可以权限关联
    this.$api.config.getNodePermission().then((res) => {
      this.isRelation = Boolean(res.data.relationFlag)
    })
  },
  methods: {
    // 关联权限改变时
    assocChange(data, i1, module) {
      if (this.form.isAccos) {
        if (i1 != 0) {
          data = data.map((item) => item.slice(0, item.length - 2))
        }
        this.treeData.map((item, i) => {
          if (i != i1) {
            let arr = i == 0 ? data : data.map((item) => item + '_' + i)
            let currentModule = item.tree.find((tree) => tree.title == module)
            if (currentModule) {
              currentModule.treeCode.push(...arr)
            }
          }
        })
      }
    },
    open(bool) {
      if (bool) {
        if (this.data.ppType == 'edit') {
          this.form = { ...this.form, ...this.data, scope: this.data.manageRange == 0 ? '仅本人' : '按部门' }
          // 获取角色配置
          this.$api.config.getRoleAttrs({}, [this.data.id]).then((res) => {
            if (res.data[0]) {
              this.selectArr = JSON.parse(res.data[0].attributeContent)
            } else {
              this.selectArr = []
            }
            if (res.data[1]) {
              this.form.isAccos = Boolean(+res.data[1].attributeContent)
            } else {
              this.form.isAccos = false
            }
          })
          // 获取默认权限码
          this.getDefaultCode()
          // 指定组织数据回显
          this.$api.role.getRoleDetail({}, [this.data.id]).then((res) => {
            this.organCode = res.data.map((item) => item.groupId)
            this.defaultTreeData()
          })
          if (!this.form.currentModule && this.moduleList.length > 0) {
            this.form.currentModule = this.moduleList[0].value
          }
        } else {
          this.selectArr = this.moduleList.map(item => item.label);
          this.form.currentModule = this.selectArr[0]
        }
      } else {
        // 初始化
        this.form = {
          model: [],
          model2: '模块1',
          treeCode: [],
          tree: [],
          scope: '按部门',
          manageRange: '',
          parentManageRange: '',
          orgLevel: 1,
          isAccos: false,
          ptArr: this.form.ptArr,
          currentModule: ''
        }
        this.selectArr = []
        // 清空权限
        this.treeData.map((item) => item.tree.map((item2) => (item2.treeCode = [])))
        this.organCode = []
        this.defaultTreeData()
        this.$refs.form.resetFields()
      }
    },
    moduleChange(list) {
      if (!this.form.currentModule && list.length > 0) {
        this.form.currentModule = list[0]
      } else {
        // 选择后取消重置高亮模块
        !list.includes(this.form.currentModule) ? this.form.currentModule = list[0] || null : ''
      }
    },
    // 角色适用节点发生变化
    nodeChange() {
      this.getModuleList()
      this.getOrganTree()
      this.getDefaultCode()
    },
    // 获取该节点所能配置的权限码
    getDefaultCode() {
      this.$api.config.getNodeAssoc({}, [this.form.orgLevel]).then(async (res) => {
        // 获取角色权限
        let roleCode = []
        if (this.data.ppType == 'edit') {
          roleCode = await this.$api.role.getRoleCodes({}, [this.data.hierachyId, this.data.id])
        }
        this.defaultCode = res.data
        this.treeData = this.permissionTree.map((item) => {
          let treeData = JSON.parse(JSON.stringify(item.tree))
          let treeList = this.filterDefaultTree(treeData)
          return {
            label: item.name,
            value: item.name,
            tree: treeList.map((tree) => {
              return { ...tree, treeCode: roleCode.data }
            })
          }
        })
      })
    },
    // 依据默认权限过滤出对应的数结构
    filterDefaultTree(data) {
      const list = (arr) => {
        return arr.filter((item) => {
          if (this.defaultCode.includes(item.code)) {
            if (item.children) item.children = list(item.children)
            if (item.childrens) item.childrens = list(item.childrens)
            return true
          } else {
            return false
          }
        })
      }
      return list(data)
    },
    async getOrganTree() {
      this.$api.config.getNodeOrgan({}, [this.form.orgLevel]).then((res) => {
        this.organTree = transitionData(res.data, {
          title: 'title',
          code: 'id',
          children: 'children',
          expand: 'add-true'
        })
      })
    },
    // 获取功能权限模块
    getModuleList() {
      if (this.form.orgLevel == this.orangList.length) {
        this.form.parentManageRange = ''
      }
      this.$api.config.getNodeAttr({}, [this.form.orgLevel]).then((res) => {
        if (res.data[0]) {
          let data = JSON.parse(res.data[0].attributeContent)
          let obj = {}
          data.map((item) => (obj[item] = true))
          this.moduleList = this.rootModuleList.filter((item) => obj[item.label])
        } else {
          this.moduleList = []
        }
        // 切换节点后清空
        this.selectArr = []
      })
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = {
            name: this.form.name,
            parentManageRange: this.form.parentManageRange,
            manageRange: this.form.scope == '仅本人' ? 0 : this.form.manageRange,
            enable: true,
            roleAttributeVos: [
              { type: 1, attributeContent: JSON.stringify(this.selectArr) },
              {
                type: 2,
                attributeContent: +this.form.isAccos
              }
            ],
            roleType: 1
          }
          if (this.form.parentManageRange == 1) {
            let selectNode = this.$refs.organTree.getCheckedNodes()
            params.parentGroups = selectNode.map((item) => ({
              groupId: item.code,
              manageRange: 4,
              manageRangeType: 1,
              relationType: 2
            }))
          }
          if (this.data.ppType == 'add') {
            this.$api.config.addDefaultRole(params, [this.form.orgLevel]).then((res) => {
              this.$Message.success('操作成功')
              this.close()
              this.$emit('refresh')
              this.saveTreeCode(res.data.hierachyId, res.data.id)
            })
          } else {
            this.$api.config
              .putDefaultRole({ ...this.data, ...params }, [this.form.orgLevel, this.data.id])
              .then((res) => {
                this.$Message.success('操作成功')
                this.close()
                this.$emit('refresh')
                this.saveTreeCode(res.data.hierachyId, res.data.id)
              })
          }
        }
      })
    },
    saveTreeCode(hierachyId, id) {
      let codes = []
      this.$refs.tree.map((item) => {
        // 过滤已选择后取消的模块权限码
        if (this.selectArr.includes(item.treeData[0]?.title)) {
          codes.push(...item.getNodes())
        }
      })
      this.$api.role.setRoleCodes(codes, [hierachyId, id])
    },
    close() {
      this.$emit('input', false)
    },
    allChange(bool) {
      if (bool) {
        this.selectArr = this.moduleList.map((item) => item.label)
        if (!this.form.currentModule && this.selectArr.length > 0) {
          this.form.currentModule = this.selectArr[0]
        }
      } else {
        this.selectArr = []
      }
    },
    // 勾选树数据
    defaultTreeData(data = this.organTree) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].children) {
          this.defaultTreeData(data[i].children)
        }
        // !data[i].children &&
        if (this.organCode.includes(data[i].code)) {
          this.$set(data[i], 'checked', true)
        } else {
          this.$set(data[i], 'checked', false)
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.ivu-form {
  .ivu-form-item-error-tip {
    margin-left: 110px;
  }
  .ivu-form-item-label {
    width: 110px;
  }
}
</style>
<style lang="less" scoped>
.node-content {
  padding-bottom: 30px;
  .tree-wrap {
    margin: 6px 110px 0;
    background: #f6f8fb;
    border: 1px solid #e9edf2;
    padding: 10px;
    height: 230px;
    overflow-y: auto;
    overflow-x: hidden;
    width: 450px;
  }
  .dep {
    position: relative;
    flex: 1;
    .tip {
      position: absolute;
      left: 270px;
      top: 0px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #f2b50d;
    }
    .dep-radio {
      margin: 6px 0 0 110px;
    }
  }
  .select-per {
    min-height: 20px;
    display: flex;
    align-items: center;
  }
  .model-wrap {
    background: #f6f8fb;
    margin: 20px 0 0;
    padding-bottom: 10px;
    .top {
      height: 64px;
      background: #ffffff;
      box-shadow: 0px 3px 2px 0px rgba(0, 0, 0, 0.03);
      border-radius: 2px 2px 0px 0px;
      border: 1px solid #e9edf2;
      display: flex;
      align-items: center;
      padding: 0 30px;
      position: relative;
      .line {
        width: 1px;
        height: 20px;
        background: #d7dfee;
        margin: 0 16px;
      }
      .right {
        display: flex;
        align-items: center;
        position: absolute;
        right: 14px;
      }
    }
    .tree-list {
      margin: 12px 15px;
      display: flex;
      width: 1190px;
      li {
        background: #fff;
        flex: 1;
        margin: 0 6px;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.14);
        border-radius: 2px;
        position: relative;
        .t1 {
          height: 40px;
          line-height: 40px;
          border-bottom: 1px solid #e8ebf1;
          font-size: 14px;
          font-family: Helvetica;
          color: #333333;
          padding-left: 20px;
        }
        .i-tree {
          padding: 20px 10px;
        }
        .no-tree {
          padding: 10px;
          // position: absolute;
          // left: 0;
          // right: 0;
          // top: 40px;
          // box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.14);
        }
      }
    }
  }
}
/deep/ .ivu-tree-title {
  width: calc(100% - 30px);
  /*height: 30px;*/
  font-size: 14px;
  font-family: PingFang-SC-Heavy, PingFang-SC;
  color: #2c3542;
  background: transparent;
  > span {
    height: 30px;
    display: inline-flex !important;
    align-items: center;
    justify-content: space-between;
  }

  &:hover {
    background: transparent;
  }
}
</style>
